import { render, staticRenderFns } from "./SameVarietyCorrectionForm.vue?vue&type=template&id=cd6a7b38&scoped=true&"
import script from "./SameVarietyCorrectionForm.vue?vue&type=script&lang=js&"
export * from "./SameVarietyCorrectionForm.vue?vue&type=script&lang=js&"
import style0 from "./SameVarietyCorrectionForm.vue?vue&type=style&index=0&id=cd6a7b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6a7b38",
  null
  
)

export default component.exports